import React, {Component} from 'react'
import request from 'superagent'
import {Button, Panel, ProgressBar} from "react-bootstrap"
import PropTypes from 'prop-types'
import ClioMatterSearch from "./ClioMatterSearch";

export default class ClioMatter extends Component {
  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    matterId: PropTypes.number,
    onMatterSelect: PropTypes.func,
  };

  state = {
    isLoading: false,
    showMatterSearch: false,
    error: null,
    matter: null,
  };

  componentDidMount() {
    this.loadMatter();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.matterId !== this.props.matterId)
      this.loadMatter();
  }

  loadMatter() {
    const {connectionId, matterId} = this.props;

    if (!matterId) return;

    this.setState({isLoading: true});

    request.get(`/rpc/integrations/connections/${connectionId}/clio/matters/${matterId}`)
      .then(response => {
        this.setState({
          isLoading: false,
          error: null,
          matter: response.body.data
        });
      })
      .catch(err => this.setState({
        isLoading: false,
        error: "Failed to load clio matter"
      }));
  }

  handleMatterSelect = (matter) => {
    this.setState({matter});

    if (this.props.onMatterSelect)
      this.props.onMatterSelect(matter);
  }

  render() {
    const {isLoading, error, matter} = this.state;

    // if the change matter button was clicked, or, there is no matter selected,
    // we will show the chooser.
    const showMatterChooser = this.state.showMatterSearch || !this.state.matter;

    if (isLoading)
      return <ProgressBar now={100} />;

    if (error)
      return <div>Failed to load Clio matter.</div>

    return (
      <div>
        {matter &&
          <Panel>
            <Panel.Heading>Clio Client</Panel.Heading>
            <Panel.Body>
              {matter.client.name}
            </Panel.Body>
          </Panel>
        }

        {!showMatterChooser &&
          <Panel>
            <Panel.Heading>Clio Matter</Panel.Heading>
            <Panel.Body>
              <b>{matter.display_number}</b> - {matter.description} <br/>
              <Button onClick={() => this.setState({showMatterSearch: true})}>Change Matter</Button>
            </Panel.Body>
          </Panel>
        }
        {showMatterChooser &&
          <Panel>
            <Panel.Heading>Search Clio Matters</Panel.Heading>
              <Panel.Body>
              <ClioMatterSearch
              connectionId={this.props.connectionId}
              onSelectMatter={this.handleMatterSelect}
              />
            </Panel.Body>
          </Panel>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/Clio/ClioMatter.jsx